
import { keyframes } from '@emotion/react';

export const pulse = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
`;

export const pulseRed = keyframes`
  0% { opacity: 1; color: inherit; }
  50% { opacity: 0.5; color: #ff0000; }
  100% { opacity: 1; color: inherit; }
`;

export const shake = keyframes`
  0% { transform: translateX(0); }
  25% { transform: translateX(-3px); }
  50% { transform: translateX(3px); }
  75% { transform: translateX(-3px); }
  100% { transform: translateX(0); }
`;

export const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
`;

export const checkmarkAnimation = keyframes`
  0% { stroke-dashoffset: 50; }
  100% { stroke-dashoffset: 0; }
`;

export const slideDown = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-10px);
    maxHeight: 0;
  }
  100% {
    opacity: 1;
    transform: translateY(0);
    maxHeight: 200px;
  }
`;

export const slideUp = keyframes`
  0% {
    opacity: 1;
    transform: translateY(0);
    maxHeight: 200px;
  }
  100% {
    opacity: 0;
    transform: translateY(-10px);
    maxHeight: 0;
  }
`;

export const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

export const fadeInUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const scaleIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

export const moneyFloat = keyframes`
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 0;
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
    opacity: 1;
  }
  100% {
    transform: translateY(-40px) rotate(360deg);
    opacity: 0;
  }
`;

export const ripple = keyframes`
  0% {
    transform: scale(0);
    opacity: 1;
    transform-origin: center;
  }
  100% {
    transform: scale(2);
    opacity: 0;
    transform-origin: center;
  }
`;

export const numberIncrement = keyframes`
  0% {
    transform: scale(1);
    color: inherit;
  }
  50% {
    transform: scale(1.1);
    color: #4caf50;
  }
  100% {
    transform: scale(1);
    color: inherit;
  }
`;

export const glow = keyframes`
  0% {
    box-shadow: 0 0 5px rgba(76, 175, 80, 0.3);
  }
  50% {
    box-shadow: 0 0 20px rgba(76, 175, 80, 0.6);
  }
  100% {
    box-shadow: 0 0 5px rgba(76, 175, 80, 0.3);
  }
`;

export const balanceUpdateGlow = keyframes`
  0% {
    transform: scale(1);
    color: inherit;
    text-shadow: none;
  }
  25% {
    transform: scale(1.05);
    color: #4caf50;
    text-shadow: 0 0 10px rgba(76, 175, 80, 0.5);
  }
  50% {
    transform: scale(1.08);
    color: #4caf50;
    text-shadow: 0 0 15px rgba(76, 175, 80, 0.7);
  }
  75% {
    transform: scale(1.03);
    color: #4caf50;
    text-shadow: 0 0 10px rgba(76, 175, 80, 0.5);
  }
  100% {
    transform: scale(1);
    color: inherit;
    text-shadow: none;
  }
`;

export const countUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  50% {
    opacity: 1;
    transform: translateY(-2px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;
